import {h, cloneElement} from 'preact';
import MediaQuery from 'react-responsive';

// todo -> write tests

import breakpoints from '../../../config/breakpoints';

const {screenSmall, screenMedium, screenLarge, screenBase} = breakpoints;

// input(em) -> tailwind.config -> breakPoints -> px
//      30em:       sm -> screenSmall -> 480px
//      47em:       md -> screenMedium -> 752px
//      64.0625em:  lg -> screenLarge -> 1024px
//      80em:       xl -> screenBase -> 1280px

export const Mobile = props => <MediaQuery {...props} maxWidth={screenSmall}/>;
export const Tablet = props => <MediaQuery {...props} minWidth={screenSmall + 1}
                                           maxWidth={screenMedium - 1}/>;

export const Desktop = props => <MediaQuery {...props} minWidth={screenLarge}/>;

export const SmallDevice = props => <MediaQuery {...props} maxWidth={screenMedium - 1}/>;
// render for anything but Mobile devices
export const MediumDevice = props => <MediaQuery {...props} minWidth={screenMedium}/>;
